import { render, staticRenderFns } from "./certincomedetail.vue?vue&type=template&id=832b86e2&scoped=true&"
import script from "./certincomedetail.vue?vue&type=script&lang=js&"
export * from "./certincomedetail.vue?vue&type=script&lang=js&"
import style0 from "./certincomedetail.vue?vue&type=style&index=0&id=832b86e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832b86e2",
  null
  
)

export default component.exports